import { SyntheticEvent, useMemo } from "react";
import { matchPath } from "react-router-dom";
import { Breadcrumb as SemanticBreadcrumb, Icon } from "semantic-ui-react";
import { CustomObject } from "framework-react-ccs";

import { useLanguage, useRoutes } from "../hooks";

export const Breadcrumb = (): JSX.Element => {
    const { t } = useLanguage();
    const { routes, navigate, setLastRegisterPath } = useRoutes();

    const handleOnClick = (event: SyntheticEvent<HTMLButtonElement>) => {
        const { route = "/" } = event.currentTarget.dataset;
        const routeLevel: string[] = [];

        let childPath = "";

        for (let index = 0; index < routes.length; index++) {
            const { pathname, handle } = routes[index];

            routeLevel.push((handle as CustomObject).crumb.path || "");

            if (pathname === route) {
                const childRoute = routes[index + 1];

                routeLevel.push(
                    (childRoute.handle as CustomObject).crumb.path || ""
                );

                childPath = childRoute.pathname;
                index = routes.length;
            }
        }

        const childRoute = matchPath(routeLevel.join("/"), childPath);

        if (!childRoute) {
            return navigate(route);
        }

        const paramsKey = Object.keys(childRoute.params);
        const currentID = childRoute.params[paramsKey[paramsKey.length - 1]];

        setLastRegisterPath(currentID || "");

        navigate(route);
    };

    const items = useMemo(() => {
        const items: JSX.Element[] = [];

        routes.forEach((route, index) => {
            const isLastItem = index >= routes.length - 1;
            const { crumb } = route.handle as CustomObject;

            const props: CustomObject = {
                link: !isLastItem,
                active: isLastItem,
            };

            if (!isLastItem) {
                props.onClick = handleOnClick;
            }

            if (crumb.routeIds) {
                (crumb.routeIds as string[]).forEach((id) => {
                    items.push(
                        <SemanticBreadcrumb.Section
                            key={`crumb-id-${id}`}
                            link={false}
                            active={false}
                            data-route={route.pathname}
                        >
                            {t(route.params[id]!)}
                        </SemanticBreadcrumb.Section>,
                        <SemanticBreadcrumb.Divider
                            key={`${crumb.title}-divider`}
                            icon={
                                <Icon
                                    color="black"
                                    inverted
                                    name="chevron right"
                                />
                            }
                        />
                    );
                });
            }

            items.push(
                <SemanticBreadcrumb.Section
                    key={crumb.title}
                    {...props}
                    data-route={route.pathname}
                >
                    {t(crumb.title)}
                </SemanticBreadcrumb.Section>
            );

            if (!isLastItem) {
                items.push(
                    <SemanticBreadcrumb.Divider
                        key={`${crumb.title}-divider`}
                        icon={
                            <Icon color="black" inverted name="chevron right" />
                        }
                    />
                );
            }
        });

        return items;
    }, routes);

    return <SemanticBreadcrumb size="mini">{items}</SemanticBreadcrumb>;
};
